exports.components = {
  "component---src-pages-editor-tsx": () => import("./../../../src/pages/editor.tsx" /* webpackChunkName: "component---src-pages-editor-tsx" */),
  "component---src-pages-preview-login-wall-tsx": () => import("./../../../src/pages/preview-login-wall.tsx" /* webpackChunkName: "component---src-pages-preview-login-wall-tsx" */),
  "component---src-templates-default-tsx": () => import("./../../../src/templates/default.tsx" /* webpackChunkName: "component---src-templates-default-tsx" */)
}

